// extracted by mini-css-extract-plugin
export default {"HistoryList":"tb_tc","centered":"tb_te","content":"tb_lA","loadMore":"tb_tf","noContent":"tb_tg","scrollButton":"tb_th"};